import { cqiConstants } from 'locale/cqi'
import { CQITabID, CQI_BASE_URL, TablesDataSource } from './utils'
import { TFunction, useTranslation } from 'react-i18next'
import BaseCQITable from './BaseCQITable'
import { NAMESPACE } from 'locale'
import { useQuery } from 'react-query'
import { getJSON } from 'common/services/api'

const CQI_CARING_URL = `${CQI_BASE_URL}/caring`

export type CaringDataFetched = {
  aboutSections: number
  personalDetails: number
  profilePictures: number
}

type AdditionalInfo = {
  residentsCount: number
}

type CaringTableProps = AdditionalInfo & {
  isLoading: boolean
}

const CaringTable = ({
  residentsCount,
  isLoading: isLoadingFromProps,
}: CaringTableProps) => {
  const { t } = useTranslation(NAMESPACE.CQI)

  const { data, isLoading } = useQuery<{ result: CaringDataFetched }>(
    ['cqi', CQITabID.Caring],
    () => getJSON({ url: CQI_CARING_URL })
  )

  return (
    <BaseCQITable
      isLoading={isLoading || isLoadingFromProps}
      dataSource={getCaringData(t, data?.result, { residentsCount })}
      tabID={CQITabID.Caring}
    />
  )
}

export const getCaringData = (
  t: TFunction<string, undefined>,
  data: CaringDataFetched | undefined,
  additionalInfo: AdditionalInfo
): TablesDataSource[] => {
  let clientsNotesSectionsCompletedOutput: string | undefined
  let clientsPersonalDetailsCompletedOutput: string | undefined
  let clientsProfilePicturesCompletedOutput: string | undefined

  if (data && additionalInfo?.residentsCount > 0) {
    if (data.aboutSections !== undefined) {
      clientsNotesSectionsCompletedOutput = `${data.aboutSections}/${additionalInfo?.residentsCount}`
    }
    if (data.personalDetails !== undefined) {
      clientsPersonalDetailsCompletedOutput = `${data.personalDetails}/${additionalInfo?.residentsCount}`
    }
    if (data.profilePictures !== undefined) {
      clientsProfilePicturesCompletedOutput = `${data.profilePictures}/${additionalInfo?.residentsCount}`
    }
  }

  return [
    {
      key: t(cqiConstants.CLIENTS_NOTES_SECTIONS_COMPLETED),
      indicator: t(cqiConstants.CLIENTS_NOTES_SECTIONS_COMPLETED),
      timeframe: t(cqiConstants.PRESENT_TIME),
      output: clientsNotesSectionsCompletedOutput,
    },
    {
      key: t(cqiConstants.CLIENTS_PERSONAL_DETAILS_COMPLETED),
      indicator: t(cqiConstants.CLIENTS_PERSONAL_DETAILS_COMPLETED),
      timeframe: t(cqiConstants.PRESENT_TIME),
      output: clientsPersonalDetailsCompletedOutput,
    },
    {
      key: t(cqiConstants.CLIENTS_WITH_PROFILE_PICTURES),
      indicator: t(cqiConstants.CLIENTS_WITH_PROFILE_PICTURES),
      timeframe: t(cqiConstants.PRESENT_TIME),
      output: clientsProfilePicturesCompletedOutput,
    },
  ]
}

export default CaringTable
